import { useSelector } from 'react-redux';
import { disableAdsBasicTariff } from 'reactApp/appHelpers/featuresHelpers/features/disableAdsBasicTariff';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';

/**
 * tempexp_20855: вариант эксперимента CLOUDWEB-20855 «убрать отключение рекламы из Основных тарифов».
 *
 * Эксперимент не применяется к корпоративным, B2B (biz) и overquota-пользователям —
 * для них всегда возвращается контроль ('a'), т.е. тексты/иконки не меняются.
 */
export const useDisableAdsBasicTariff = (): 'a' | 'b' | 'c' => {
    const isCorp = useSelector(UserSelectors.isCorpUser);
    const isBiz = useSelector(UserSelectors.isBizUser);
    const isOverquota = useSelector(UserQuotaSelectors.isOverquota);

    if (isCorp || isBiz || isOverquota) {
        return 'a';
    }

    return disableAdsBasicTariff;
};
